import React, { FC, PropsWithChildren, useMemo, useState } from "react";

import mobileIntegration from "@/integration";

export enum ViewMode {
    FULL = "full",
    FRAGMENT = "fragment",
}

export const ViewModeContext = React.createContext({ viewMode: ViewMode.FULL });
ViewModeContext.displayName = "ViewModeContext";

export const ViewModeProvider: FC<PropsWithChildren> = ({ children }) => {
    const [viewMode, setViewMode] = useState(mobileIntegration.isNativeApp() ? ViewMode.FRAGMENT : ViewMode.FULL);

    const contextValue = useMemo(
        () => ({
            viewMode,
            setViewMode,
        }),
        [viewMode],
    );

    return <ViewModeContext.Provider value={contextValue}>{children}</ViewModeContext.Provider>;
};
